import { is } from '../util/is';

export type CollectionArray<T> = T[];
export type CollectionObject<T> = Record<string, T>;
/**
 * A data structure that can contain multiple elements of the same type.
 */
export type Collection<T> = CollectionArray<T> | CollectionObject<T>;

/**
 * accepts string or number because object converts number to string
 */
export type CollectionIndexer<T> = CollectionObject<T>;

export function isCollectionArray<T>(f: Collection<T>): f is CollectionArray<T> {
  return is(Array, f);
}

export function isCollectionObject<T>(f: Collection<T>): f is CollectionObject<T> {
  return is(Object, f);
}
